// Vendor imports
const React = require('react')
// Client V2 common imports
const PopperAnchor = require('client-v2/common/components/popper-anchor')
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const TooltipBubble = require('./components/bubble')

function WithTooltip(props) {
  // Hooks
  const renderPopper = useRenderPopper(props)
  // Render
  if (!props.renderBubbleChildren) {
    return props.children
  }
  return (
    tag(PopperAnchor, {
      isDisabled: props.isDisabled,
      modifiers: props.modifiers,
      placement: props.placement,
      portalContainer: props.portalContainer,
      updateAfterResizeDelay: props.updateAfterResizeDelay,
      renderPopper
    },
      props.children
    )
  )
}

WithTooltip.defaultProps = {
  portalContainer: '#modal-root',
  updateAfterResizeDelay: 300
}

function useRenderPopper({
  isDismissed,
  className,
  tooltipKey,
  renderBubbleChildren,
  onDismiss
}) {
  const dismissTooltip = React.useCallback(
    event => {
      if (onDismiss) {
        event.stopPropagation()
        onDismiss(tooltipKey)
      }
    },
    [ onDismiss, tooltipKey ]
  )
  return React.useCallback(
    popperProps => (
      tag(TooltipBubble, {
        // Popper props
        arrowRef: popperProps.arrowProps.ref,
        arrowStyle: popperProps.arrowProps.style,
        popperPlacement: popperProps.placement,
        popperRef: popperProps.ref,
        popperStyle: popperProps.style,
        // Component props
        isDismissed,
        className,
        tooltipKey,
        onDismiss: dismissTooltip
      },
        renderBubbleChildren()
      )
    ),
    [
      className, tooltipKey, isDismissed,
      renderBubbleChildren, dismissTooltip
    ]
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  WithTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    // PopperAnchor props
    modifiers: PopperAnchor.propTypes.modifiers,
    placement: PopperAnchor.propTypes.placement,
    portalContainer: PopperAnchor.propTypes.portalContainer,
    updateAfterResizeDelay: PopperAnchor.propTypes.updateAfterResizeDelay,
    // Flags
    isDisabled: PropTypes.bool,
    isDismissed: PropTypes.bool,
    // Values
    className: PropTypes.string,
    tooltipKey: PropTypes.string.isRequired,
    // Render props
    renderBubbleChildren: PropTypes.func,
    // Callbacks
    onDismiss: PropTypes.func.isRequired
  }
}

module.exports = WithTooltip
